module.exports = __webpack_public_path__ + "e92252101ca270b0b736464804a2f603.svg";